import { css } from 'styled-components';

const VerticalCenter = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
`;

export default VerticalCenter;
